import React from "react";
import Layout from "../../../component/Layout";
import RRtestCenterImg from "../../../images/RRtestCenterImg.png";
import RRTestHeader from "./RRTestHeader";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import { Link } from "react-router-dom";

const RRTestStep1 = () => {
  return (
    <Layout>
      <div className="relative h-full bg-[#f6f6f6] testbg pb-5  overflow-y-auto">
        <RRTestHeader />
        <div className="w-full max-w-2xl mx-auto px-5 pb-5">
          <div className="relative text-center mb-[58px]">
            <p className="text-black text-base font-normal">Step 1</p>
            <Link to="/rrteststep1">
              <span className="absolute left-0 top-1/2 -translate-y-1/2">
                <ArrowL />
              </span>
            </Link>
          </div>
          <Link to="/rrtestresult1 " className="mx-auto w-fit block mb-[30px]">
            <div style={{ width: 174, height: 174 }}>
              <CircularProgressbarWithChildren
                strokeWidth={5}
                value={60}
                styles={buildStyles({
                  textColor: "#000", // Text color
                  pathColor: "#00901E", // Progress path color
                  trailColor: "#E5E5E5", // Background path color
                })}
              >
                <img
                  src={RRtestCenterImg}
                  alt="testCenterImg"
                  className="w-[92px] h-[68px] mb-2"
                />
                <span className="text-black text-[12px] font-normal leading-[91%] uppercase">
                  run rocket
                </span>
              </CircularProgressbarWithChildren>
            </div>
          </Link>
          <div className="flex flex-col gap-2 mb-10">
            <div className="flex flex-row justify-center gap-12">
              <div className="space-y-2 text-center">
                <p className="text-[#a5a5a5] text-xs font-normal uppercase">
                  REPS
                </p>
                <p className="text-black text-sm font-normal">35lbs</p>
              </div>
              <div className="space-y-2 text-center">
                <p className="text-[#a5a5a5] text-xs font-normal uppercase">
                  Distance
                </p>
                <p className="text-black text-sm font-normal">250m</p>
              </div>
              <div className="space-y-2 text-center">
                <p className="text-[#a5a5a5] text-xs font-normal uppercase">
                  LOAD
                </p>
                <p className="text-black text-sm font-normal">8.55</p>
              </div>
            </div>
            <div className="relative w-full max-w-[244px] border-b border-black mx-auto">
              <input
                type="text"
                placeholder="Enter your speed"
                className="bg-transparent w-full outline-none p-[19px_60px_19px_20px] placeholder:text-[#A5A5A5] text-black text-xl font-normal"
              />
              <span className="absolute right-5 top-1/2 -translate-y-1/2">
                <Add />
              </span>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default RRTestStep1;

const ArrowL = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M7 13L1 7L7 1"
        stroke="#000"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const Add = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
    >
      <path
        d="M10.5 1V21M0.5 11C8.31049 11 12.6895 11 20.5 11"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
